import React, { memo, useContext } from 'react';

import Button from 'b2b-ui-components-lib/lib/components/button';
import BaseCarousel from 'b2b-ui-components-lib/lib/components/baseCarousel';

import { AppContext } from 'App';

import { PlanSlider } from 'home/view/check-feasibility/unauth-view/constant';
import { getImageSrc } from 'common/utils/app.utils';

import './Plans.scss';

const Plans = ({ onPlanClick }) => {
  const { pageData } = useContext(AppContext);
  const { heading, list } = pageData?.plans;

  list?.map((item) => {
    item['image'] = getImageSrc(item);
  });

  BaseCarousel.defaultProps = {
    ...PlanSlider,
    carouselContainerClass: ''
  };
  return (
    <section className="plan_section_controller" id="planSection">
      <div className="container">
        <h2 className="plan_head">{heading}</h2>
        <BaseCarousel>
          {list?.map((item, index) => (
            <div className="plan_box" key={index}>
              {item?.recommended && <div className="recommended_tag">{item?.recommended_text}</div>}
              <div className="plan_head">{item?.bandwidth}</div>
              <div className="plan_body">
                <div className="plan_price">
                  <span className="price_text">{item?.title}</span>
                </div>
                <div className="progress_box">
                  <img src={item?.image} alt="Plan Image" />
                </div>
                <div className="plan_desc">{item?.description}</div>
                <div className="features">
                  <ul className="features_list">
                    {item?.features?.map((item, index) => (
                      <li key={index}>
                        {item?.title}
                        <span>{item?.subTitle}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="plan_action">
                <Button displayName={item?.cta_name} variant={item?.selected ? 'activebtn' : 'outlinebtn'} onClick={(e) => onPlanClick(e, item?.bandwidth)} />
              </div>
            </div>
          ))}
        </BaseCarousel>
      </div>
    </section>
  );
};

export default memo(Plans);
